import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import "./Search.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import GATracker from "../components/GATracker";

import { SearchType } from "../../api/ReplayVariables";
import ChanelReplays from "../components/ChanelReplays";
import { LoadingContext } from "../../api/loading/LoadingContext";

const LoadingAnimation = require("react-loading-animation");

function Search({ location, category, startUrl = "/replays", my = false }) {
  const [data, setData] = useState(null);
  const [lastCategory, setLastCategory] = useState(null);
  const [lastMy, setLastMy] = useState(false);
  const { loading, dispatchLoading } = useContext(LoadingContext);

  useEffect(() => {
    //console.log("search effect");
    if (lastCategory !== category || lastMy !== my) {
      setLastCategory((c) => category);
      setLastMy((m) => my);
      dispatchLoading({ type: "update", payload: 10 });
      let url =
        window.serverUrl+"/social/search.php?category=" +
        category +
        "&my=" +
        my;
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          setData((d) => _data);
          setTimeout(() => {
            dispatchLoading({ type: "update", payload: 100 });
          }, 500);
        })
        .catch((err) => {
          setTimeout(() => {
            dispatchLoading({ type: "update", payload: 100 });
          });
          console.error("fetch problem", err);
        });
    }
    return () => {
      //console.log("search done");
    };
  }, [category, my, lastCategory, lastMy, data, dispatchLoading]);

  return (
    <>
      <GATracker></GATracker>
      <PerfectScrollbar className="search chanel-scroll main-scroll">
        <div className="chanel-container d-flex flex-column">
          {data !== null && loading.progress === 100 ? (
            <ChanelReplays
              location={location}
              params={{
                category: category,
                my: my
              }}
              startUrl={startUrl}
              queryUrl={window.serverUrl+"/social/search.php"}
              data={data}
            ></ChanelReplays>
          ) : (
            <div className="loading-container">
              <LoadingAnimation className="test" />
            </div>
          )}
        </div>
      </PerfectScrollbar>
    </>
  );
}
Search.propTypes = {
  category: PropTypes.oneOf(Object.keys(SearchType)).isRequired
};
export default Search;
